/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsMatchHistoryDtoSchema } from "./matchHistoryDtoSchema.ts";
import { goodLuckCoreDTOsRosterCurrentUserContextSchema } from "./rosterCurrentUserContextSchema.ts";
import { goodLuckCoreDTOsRosterMemberResponseSchema } from "./rosterMemberResponseSchema.ts";
import { goodLuckCoreDTOsRosterTournamentHistoryItemDtoSchema } from "./rosterTournamentHistoryItemDtoSchema.ts";
import { goodLuckCoreDTOsTeamExtendedStatsDtoSchema } from "./teamExtendedStatsDtoSchema.ts";
import { goodLuckCoreEntitiesRosterOriginSchema } from "../entities/rosterOriginSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsRosterResponseSchema = z.object({
  id: z.string().nullish(),
  name: z.string().nullish(),
  tag: z.string().nullish(),
  icon: z.string().nullish(),
  banner: z.string().nullish(),
  description: z.string().nullish(),
  captainId: z.string().nullish(),
  captainName: z.string().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  status: z.string().nullish(),
  invitationToken: z.string().nullish(),
  tournamentId: z.string().nullish(),
  isTemporary: z.optional(z.boolean()),
  get origin() {
    return goodLuckCoreEntitiesRosterOriginSchema.optional();
  },
  isLookingForPartner: z.optional(z.boolean()),
  acceptScrimInvites: z.optional(z.boolean()),
  isVerified: z.optional(z.boolean()),
  archivedAt: z.iso.datetime().nullish(),
  get members() {
    return z.array(goodLuckCoreDTOsRosterMemberResponseSchema).nullish();
  },
  get matchHistory() {
    return z.array(goodLuckCoreDTOsMatchHistoryDtoSchema).nullish();
  },
  position: z.string().nullish(),
  prize: z.number().nullish(),
  matchWins: z.optional(z.int()),
  matchLosses: z.optional(z.int()),
  matchWinrate: z.optional(z.number()),
  kda: z.string().nullish(),
  totalTournaments: z.optional(z.int()),
  tournamentWins: z.optional(z.int()),
  tournamentWinrate: z.optional(z.number()),
  get tournaments() {
    return z
      .array(goodLuckCoreDTOsRosterTournamentHistoryItemDtoSchema)
      .nullish();
  },
  get extendedStats() {
    return goodLuckCoreDTOsTeamExtendedStatsDtoSchema.optional();
  },
  get currentUser() {
    return goodLuckCoreDTOsRosterCurrentUserContextSchema.optional();
  },
  discordVoiceChannelUrl: z.string().nullish(),
});
